<input class="form-control" id="google-add-{{id}}" type="text" #searchDeliveryPlace autocomplete="off"
    placeholder="Enter a location">